//请自行添加语言资源
const orderImport = {
  shipperName: '货主',
  companyName: '所属机构',
  importFileName: '导入文件名称',
  processFileName: '结果文件名称',
  orderCount: '总单数',
  dealStatus: '处理状态',
  dealTime: '处理时间',
  dealResult: '处理结果',
  createTime: '创建时间',
  creator: '创建者',
  msg: {}
};
export default orderImport



// WEBPACK FOOTER //
// ./src/page/order/orderImport/lang/orderImport.zh.js